import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";
import SortBy from "../../helpers/SortBy";

import search from "../../search.png";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import Xlsx from "../../exporter/Xlsx";
import MenuTable from "../../helpers/MenuTable";
import LessonOb from "./LessonOb";
import LessonRaport from "./LessonRaport";

import back from "../../back.png";


function LessonExtra(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({
  
        nazwa: '',
 

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
    
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

    });

    const [tab, setTab] = useState(null);
 

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );




    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');
        var title = e.target.getAttribute('atr-title');

        setView({...view, ["v"]:v, ["id"]:id,['title']: title });
    }


    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_kids,zajecia_dodatkowe', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  

                       

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }



    
    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
  
        props.mainView.writeFilter('nazwa', ''); 
     

        setFilterParam({
                 
            nazwa: '', 
          
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
                                       
            limit: 50,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }



 
    
    if(tab == null)
        {
            setTab([]);
            getTab();
        
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }


 

    var sortList = [                
        {column: "nazwa", name: "Nazwa"  }, 
      
]



    if(view.v == 'ob')
    {
        return <LessonOb  userData={props.userData} mainView={props.mainView} id={view.id}  onBack={onBack} title={view.title} />
    }

     if(view.v == 'rp')
    {
        return <LessonRaport  userData={props.userData} mainView={props.mainView} id={view.id}  onBack={onBack} title={view.title} />
    }
 

    return <div className="view_content">
 

                
                <div className="bg_center">



                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                                     
                        <div className="filter_controll">   
                            <label>Nazwa: </label>                             
                            <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                       </div> 
 
                         <div className="filter_btn">
                            <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                  </div>
                } 
                           


                            <div className="table_widget">
                                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                            
                                          
                                            &nbsp; &nbsp;
                                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Zajęcia dodatkowe" />   
                                            <Csv tabRef={tab2Ref}  title="zajęciadodatkowe.csv" />                  
                                            <Xlsx tabRef={tab2Ref} title="zajęciadodatkowe.xlsx" />                  
                                            <Print tabRef={tab2Ref} />

                                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                                </div>


                                <div ref={tabRef} className="gohide">
                                     <table className="table" ref={tab2Ref} >
                                                    <thead>
                                                        <tr className="header">                                                                                                       
                                                            <td className="td_left">LP</td>  
                                                            <td>Nazwa</td>                                                                                                                                                                                                                                                                                                                    
                                                            <td>Prawadzący/a</td>                                                                                                                                                                                                
                                                            <td className="td_right">Terminy</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row,ix) => {

                                                              
                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return <tr className={rowStyle}>                                                                                                       
                                                                    <td onClick={changeView} v="ob" id={row.id} atr-title={row.nazwa} >{ix+1}</td>  
                                                                    <td className="goleft" onClick={changeView} v="ob" id={row.id} atr-title={row.nazwa}  >{row.nazwa}</td>                                             
                                                                    <td onClick={changeView} v="ob" id={row.id} atr-title={row.nazwa} >{row.prawadzacy.imie} {row.prawadzacy.nazwisko}</td>
                                                                    <td>
                                                                        {
                                                                            row.terminy.map( (term, inxT) => {

                                                                                return <span>
                                                                                    { term.dzien_tygodnia == 0 && <span>Niedziela</span>     } 
                                                                                    { term.dzien_tygodnia == 1 && <span>Poniedziałek</span>     } 
                                                                                    { term.dzien_tygodnia == 2 && <span>Wtorek</span>     } 
                                                                                    { term.dzien_tygodnia == 3 && <span>Środa</span>     } 
                                                                                    { term.dzien_tygodnia == 4 && <span>Czwartek</span>     } 
                                                                                    { term.dzien_tygodnia == 5 && <span>Piątek</span>     } 
                                                                                    { term.dzien_tygodnia == 6 && <span>Sobota</span>     } 
                                                                                    &nbsp;
                                                                                    {term.godzina.substr(0,5)}
                                                                                    &nbsp; &nbsp;    &nbsp; &nbsp;
                                                                                </span>
                                                                            } )
                                                                        }
                                                                    </td>
                                                                   
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                                </tr>    

                                                            } )
                                                        }

                                                 
                                                    </tbody>
                                </table>
                                </div>



                            <div className="scorll_x">
                                <table className="table" >
                                                    <thead>
                                                        <tr className="header">                                                                                                       
                                                            <td className="td_left">LP</td>  
                                                            <td>Nazwa</td>                                                                                                                                                                                                                                                                                                                    
                                                            <td>Prawadzący/a</td>                                                                                                                                                                                                
                                                            <td className="td_right">Terminy</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                            <td className="td_option"></td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row,ix) => {

                                                              
                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return <tr className={rowStyle}>                                                                                                       
                                                                    <td onClick={changeView} v="ob" id={row.id} atr-title={row.nazwa} >{ix+1}</td>  
                                                                    <td className="goleft" onClick={changeView} v="ob" id={row.id} atr-title={row.nazwa}  >{row.nazwa}</td>                                             
                                                                    <td onClick={changeView} v="ob" id={row.id} atr-title={row.nazwa} >{row.prawadzacy.imie} {row.prawadzacy.nazwisko}</td>
                                                                    <td>
                                                                        {
                                                                            row.terminy.map( (term, inxT) => {

                                                                                return <span>
                                                                                    { term.dzien_tygodnia == 0 && <span>Niedziela</span>     } 
                                                                                    { term.dzien_tygodnia == 1 && <span>Poniedziałek</span>     } 
                                                                                    { term.dzien_tygodnia == 2 && <span>Wtorek</span>     } 
                                                                                    { term.dzien_tygodnia == 3 && <span>Środa</span>     } 
                                                                                    { term.dzien_tygodnia == 4 && <span>Czwartek</span>     } 
                                                                                    { term.dzien_tygodnia == 5 && <span>Piątek</span>     } 
                                                                                    { term.dzien_tygodnia == 6 && <span>Sobota</span>     } 
                                                                                    &nbsp;
                                                                                    {term.godzina.substr(0,5)}
                                                                                    &nbsp; &nbsp;    &nbsp; &nbsp;
                                                                                </span>
                                                                            } )
                                                                        }
                                                                    </td>
                                                                     <MenuTable>
                                                                        <ul>
                                                                            <li onClick={changeView} v="ob" id={row.id} atr-title={row.nazwa} >obecności dzieci</li>                                                                      
                                                                            <li onClick={changeView} v="rp" id={row.id} atr-title={row.nazwa} >raport miesięczny</li>                                                                      
                                                                        </ul>
                                                                    </MenuTable>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                                </tr>    

                                                            } )
                                                        }

                                                 
                                                    </tbody>
                                </table>
                            </div>


                </div>

               


           </div>
}




export default LessonExtra;